import { Injectable, NgZone } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private initialized = false;
  private updatePending = false;
  private reloading = false;

  private readonly CHECK_INTERVAL_MS = 30 * 60 * 1000; // 30 min

  constructor(
    private swUpdate: SwUpdate,
    private router: Router,
    private zone: NgZone
  ) {}

  init() {
    if (!this.swUpdate.isEnabled || this.initialized) return;
    this.initialized = true;

    this.listenControllerChange();
    this.listenVersionUpdates();
    this.listenNavigation();
    this.startUpdateChecks();

    // Check inmediato al arrancar
    this.swUpdate.checkForUpdate().catch(() => {});
  }

  private listenControllerChange() {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.reloading) return;
      this.reloading = true;
      window.location.reload();
    });
  }

  private listenVersionUpdates() {
    this.swUpdate.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          // Solo diagnóstico (opcional)
          // console.log('[PWA] Update detected, downloading...');
          break;

        case 'VERSION_READY': {
          const e = evt as VersionReadyEvent;
          console.log('[PWA] Update ready', {
            current: e.currentVersion.hash,
            latest: e.latestVersion.hash,
          });

          this.updatePending = true;
          void this.tryApplyIfHome(this.router.url);
          break;
        }

        case 'VERSION_INSTALLATION_FAILED':
          console.warn('[PWA] Installation failed:', evt);
          break;
      }
    });
  }

  private listenNavigation() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        void this.tryApplyIfHome(e.urlAfterRedirects);
      });
  }

  private startUpdateChecks() {
    this.zone.runOutsideAngular(() => {
      setInterval(() => {
        this.swUpdate.checkForUpdate().catch(() => {});
      }, this.CHECK_INTERVAL_MS);

      // // ✅ Check al volver a primer plano
      // document.addEventListener('visibilitychange', () => {
      //   if (document.visibilityState === 'visible') {
      //     this.swUpdate.checkForUpdate().catch(() => {});
      //   }
      // });

      // // ✅ Check cuando vuelve la conectividad
      // window.addEventListener('online', () => {
      //   this.swUpdate.checkForUpdate().catch(() => {});
      // });
    });
  }

  private isHome(url: string): boolean {
    // Ajustá si tu home real es /tabs/home, etc.
    return url === '/home' || url.startsWith('/home?') || url.startsWith('/home/');
  }

  private async tryApplyIfHome(url: string) {
    if (!this.updatePending || !this.isHome(url) || this.reloading) return;

    try {
      await this.swUpdate.activateUpdate();

      // Normalmente recarga controllerchange; esto es fallback
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          if (!this.reloading) {
            this.reloading = true;
            window.location.reload();
          }
        }, 1500);
      });
    } catch (e) {
      console.error('[PWA] activateUpdate failed', e);
      this.updatePending = false;
    }
  }
}
